import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import { packageMeta } from "@/lib/packages";
import { Clock, ArrowRight } from "lucide-react";


const API = `${process.env.REACT_APP_BACKEND_URL}/api`;





export default function Packages() {
  const { t, lang } = useLang();
  const [packages, setPackages] = useState([]);



  // Supondo que você tenha uma variável ou estado, por exemplo: const isActive = true;

  useEffect(() => {
    axios.get(`${API}/packages`, {
      params: {
        show_in_homepage:true // ou false, ou uma variável do seu estado
      }
    })
    .then(r => setPackages(r.data))
    .catch(() => {});
  }, []); // Se usar uma variável de estado aqui, lembre-se de colocá-la no array de dependências

/*
  useEffect(() => {
    axios.get(`${API}/packages`).then(r => setPackages(r.data)).catch(() => {});
  }, []);
*/
  const scrollToBook = (pkgId) => {
    const el = document.getElementById("book");
    if (el) {
      window.dispatchEvent(new CustomEvent("prefill-package", { detail: pkgId }));
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="tours" data-testid="packages-section" className="py-24 md:py-32 bg-white border-y border-jungle/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-4">
          <div className="max-w-2xl">
            <div className="font-overline text-terracotta text-xs mb-3">{t.packages.overline}</div>
            <h2 className="font-display text-4xl md:text-6xl text-jungle leading-[1.05]">{t.packages.title}</h2>
          </div>
          <p className="text-forest max-w-md text-sm md:text-base">{t.packages.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((pkg) => {
            const meta = packageMeta[pkg.id] || {};
            return (
              <div
                key={pkg.id}
                data-testid={`package-card-${pkg.id}`}
                className="group border border-jungle/15 bg-sand overflow-hidden flex flex-col"
              >
                <Link to={`/tandem/${pkg.id}`} data-testid={`package-detail-link-${pkg.id}`} className="relative aspect-[4/3] overflow-hidden block">
                  <img src={meta.image} alt={pkg.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {meta.tag && (
                    <span className="absolute top-4 left-4 bg-terracotta text-white text-[10px] font-overline px-3 py-1.5">
                      {meta.tag[lang] || meta.tag.en}
                    </span>
                  )}
                </Link>
                <div className="p-6 flex-1 flex flex-col">
                  <Link to={`/tandem/${pkg.id}`} className="hover:text-terracotta transition-colors">
                    <h3 className="font-display text-2xl text-jungle">{pkg.name}</h3>
                  </Link>
                  <div className="text-forest text-sm mt-1">{pkg.location}</div>
                  <div className="flex items-center gap-2 mt-3 text-forest text-xs">
                    <Clock size={14} /> {pkg.duration_min} {t.packages.duration}
                  </div>
                  <div className="mt-5 pt-5 border-t border-jungle/10 flex items-end justify-between">
                    <div>
                      <div className="font-overline text-[10px] text-forest">{t.destinations.from}</div>
                      <div className="font-display text-3xl text-jungle leading-none">${pkg.full_price}</div>
                      <div className="text-[10px] text-forest mt-1">{t.destinations.per_person}</div>
                    </div>
                    <div className="flex flex-col gap-2 items-end">
                      <Link to={`/tandem/${pkg.id}`} data-testid={`package-details-btn-${pkg.id}`} className="font-overline text-[10px] text-forest hover:text-terracotta transition-colors">
                        Details →
                      </Link>
                      <button
                        data-testid={`package-book-btn-${pkg.id}`}
                        onClick={() => scrollToBook(pkg.id)}
                        className="btn-primary"
                        style={{padding: "10px 16px", fontSize: "11px"}}
                      >
                        {t.packages.book_now} <ArrowRight size={14} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="text-forest text-xs mt-6 italic">{t.packages.includes}</p>
      </div>
    </section>
  );
}
